module.exports = __webpack_public_path__ + "static/media/pic2.c999de4b.jfif";